import axios from 'axios'

axios.defaults.baseURL = import.meta.env.VITE_ROOT_API
axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

let refreshPromise = null
let csrfToken = null

axios.interceptors.request.use(function (config) {
  if (typeof window === 'undefined') {
    return config
  }
  config.withCredentials = true
  config.headers = config.headers || {}
  if (isUnsafeMethod(config.method)) {
    const token = csrfToken || getCookieValue('XSRF-TOKEN')
    if (token) {
      config.headers['X-XSRF-TOKEN'] = token
    }
  }

  return config
})

const UNAUTHORIZED = 401
axios.interceptors.response.use(
  response => response,
  async error => {
    const response = error.response
    const originalRequest = error.config
    if (!response || response.status !== UNAUTHORIZED || !originalRequest) {
      return Promise.reject(error)
    }

    if (isAuthEndpoint(originalRequest.url) || originalRequest._retry) {
      redirectToLogin()
      return Promise.reject(error)
    }

    originalRequest._retry = true
    try {
      if (!refreshPromise) {
        refreshPromise = axios.post('/auth/refresh')
          .then(() => axios.get('/auth/csrf'))
          .then(() => {
            clearCsrfToken()
          })
          .finally(() => {
            refreshPromise = null
          })
      }
      await refreshPromise
      return axios(originalRequest)
    } catch (refreshError) {
      redirectToLogin()
      return Promise.reject(refreshError)
    }
  }
)

function isUnsafeMethod (method = 'get') {
  return ['post', 'put', 'patch', 'delete'].includes(method.toLowerCase())
}

function isAuthEndpoint (url = '') {
  return url.includes('/auth/login') || url.includes('/auth/refresh')
}

function getCookieValue (name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
    ?.split('=')[1]
}

function redirectToLogin () {
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login'
  }
}

export function clearCsrfToken () {
  csrfToken = null
}

export default axios
